module.exports = {"pathContext":{"name":"OutlookSyncStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"FAILED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"SUCCESS"}],"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/enum-outlook-sync-status.json
// module id = 1274
// module chunks = 224770256810939